/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CheckKYCCompletionMutationVariables = {|
  userId: string
|};
export type CheckKYCCompletionMutationResponse = {|
  +kycComplete: ?{|
    +message: ?boolean
  |}
|};
export type CheckKYCCompletionMutation = {|
  variables: CheckKYCCompletionMutationVariables,
  response: CheckKYCCompletionMutationResponse,
|};
*/


/*
mutation CheckKYCCompletionMutation(
  $userId: String!
) {
  kycComplete(userId: $userId) {
    message
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "userId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "userId",
        "variableName": "userId"
      }
    ],
    "concreteType": "KYCComplete",
    "kind": "LinkedField",
    "name": "kycComplete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CheckKYCCompletionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CheckKYCCompletionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fbc6b61e813526daaf8a4996cad992b9",
    "id": null,
    "metadata": {},
    "name": "CheckKYCCompletionMutation",
    "operationKind": "mutation",
    "text": "mutation CheckKYCCompletionMutation(\n  $userId: String!\n) {\n  kycComplete(userId: $userId) {\n    message\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bd5b00b7250846636623dd40fd6fe963';

module.exports = node;
